module.exports = __webpack_public_path__ + "img/ic_documnetlist.4d32fead.svg";